import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import './Proyectos.css';

// Importa el componente del cliente

import HotelDancar from '../../clientes/Hotel-Dancar';
import HotelHyR from '../../clientes/HotelHyR';
import TanquesNazareth from './TanquesNazareth';
import LuisMadrid from './LuisMadrid';

const Proyectos = ({ clienteId, setIsModalOpen }) => {
  // 👉 AÑADIDO PARA ACTIVAR SCROLL SOLO AQUÍ
  useEffect(() => {
    document.body.classList.add('proyectos');
    document.documentElement.classList.add('proyectos');

    return () => {
      document.body.classList.remove('proyectos');
      document.documentElement.classList.remove('proyectos');
    };
  }, []);
  // 👉 FIN CAMBIO

  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const [cards] = useState([
    {
      id: 1,
      slug: 'tanque-nazareth',
      title: 'Tanques Casa Nazareth',
      content: 'Instalación de Termotanques',
      background: require('./assets/TanquesNazareth/Fondo.png'),
      backgroundMobile: require('./assets/TanquesNazareth/FondoCel.png'),
      image: require('../../../assets/CasaNazareth.avif'),
    },

    {
      id: 2,
      slug: 'Hotel HyR',
      title: 'Hotel H&R',
      content: 'Instalacion de Sistema Termosolar',
      image: require('../assets/HotelHyR/Tarjeta.png'),
      background: require('../assets/HotelHyR/Fondo.png'),
      backgroundMobile: require('../assets/HotelHyR/FondoCel.png'),
    },

    {
      id: 3,
      slug: 'HotelDancar',
      title: 'Hotel Dancar',
      content: 'Instalación de Termotanques',
      image: require('../assets/HotelDancar/tarjeta.png'),
      background: require('../assets/HotelDancar/fondo.png'),
      backgroundMobile: require('../assets/HotelDancar/FondoCel.png'),
    },

     {
      id: 4,
      slug: 'LuisMadrid',
      title: 'Luis Madrid',
      content: 'Instalación de Termotanques',
      image: require('./assets/LuisMadrid/Tarjeta.png'),
      background: require('./assets/LuisMadrid/Fondo.png'),
      backgroundMobile: require('./assets/LuisMadrid/FondoCel.png'),
    },



  ]);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkSize(); // ejecuta al cargar
    window.addEventListener('resize', checkSize);

    return () => window.removeEventListener('resize', checkSize);
  }, []);

  const carouselRef = useRef(null);

  const setBackgroundImage = useCallback(
    (card) => {
      const backgroundElement = document.querySelector('.background');
      if (!backgroundElement) return;

      const imageUrl =
        isMobile && card?.backgroundMobile
          ? card.backgroundMobile
          : (card?.background ?? card?.image);

      backgroundElement.style.backgroundImage = `url(${imageUrl})`;
    },
    [isMobile]
  );

  // Sincroniza si la ruta trae un índice numérico
  useEffect(() => {
    if (!clienteId) return;
    const parsedIndex = Number.parseInt(clienteId, 10);

    if (
      !Number.isNaN(parsedIndex) &&
      parsedIndex >= 0 &&
      parsedIndex < cards.length
    ) {
      setCurrentIndex(parsedIndex);
      setShowModal(false);
    }
  }, [clienteId, cards.length]);

  useEffect(() => {
    setBackgroundImage(cards[currentIndex]);
  }, [currentIndex, cards, setBackgroundImage, isMobile]);

  useEffect(() => {
    const container = carouselRef.current;
    if (!container) return;

    requestAnimationFrame(() => {
      const el = container.children[currentIndex];
      if (!el) return;

      const styles = getComputedStyle(container);
      const padLeft = parseFloat(styles.paddingLeft) || 0;
      const padRight = parseFloat(styles.paddingRight) || 0;

      const cardWidth = el.offsetWidth;
      const containerWidth = container.clientWidth;

      // Centro ideal considerando el padding interno
      const desired =
        el.offsetLeft - // ya incluye padLeft en el offset
        (containerWidth - padLeft - padRight) / 2 +
        cardWidth / 2;

      const maxScroll = Math.max(
        0,
        container.scrollWidth - container.clientWidth
      );
      const clamped = Math.min(Math.max(desired, 0), maxScroll);

      container.scrollTo({ left: clamped, behavior: 'smooth' });
    });
  }, [currentIndex]);

  const handleNavigation = useCallback(
    (newIndex) => {
      if (newIndex === currentIndex) return;
      const url = showModal
        ? `/clientes/termosolares/${cards[newIndex].slug}`
        : `/clientes/termosolares/${newIndex}`;
      navigate(url, { replace: false });
    },
    [currentIndex, showModal, cards, navigate]
  );

  const handleCardClick = (index) => {
    // Si el usuario hace clic en la misma tarjeta activa
    if (index === currentIndex) {
      setShowModal(true);
      setIsModalOpen?.(true);
      const slug = cards[index].slug;
      navigate(`/clientes/termosolares/${slug}`);
    } else {
      // Si es una tarjeta diferente, solo navega normalmente
      handleNavigation(index);
    }
  };

  const handleDotClick = (index) => handleNavigation(index);
  const handleIndicatorArrowClick = (direction) => {
    const newIndex = (currentIndex + direction + cards.length) % cards.length;
    handleNavigation(newIndex);
  };

  const handleVerProyectoClick = () => {
    setShowModal(true);
    setIsModalOpen?.(true); // ← Notifica al swipe que se desactive
    const slug = cards[currentIndex].slug;
    navigate(`/clientes/termosolares/${slug}`);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsModalOpen?.(false); // ← Notifica al swipe que se reactive
    navigate(`/clientes/termosolares/${currentIndex}`);
  };

  const clientComponents = {
    'Tanques Casa Nazareth': <TanquesNazareth />,
    'Luis Madrid': <LuisMadrid/>,
    'Hotel Dancar': <HotelDancar />,
    'Hotel H&R': <HotelHyR />,
   
  };

  const clienteComponent = clientComponents[cards[currentIndex]?.title];

  // Sincroniza cuando la ruta trae un slug
  useEffect(() => {
    if (!clienteId) return;
    const slugIndex = cards.findIndex((card) => card.slug === clienteId);
    if (slugIndex !== -1) {
      setCurrentIndex(slugIndex);
      setShowModal(true);
      setIsModalOpen?.(true);
    }
  }, [clienteId, cards, setIsModalOpen]);

  return (
    <section id="Termosolares" className="clientes-section">
      <Helmet>
        {/* Meta SEO general */}
        <title>{cards[currentIndex].title} | Clientes | Termosolares</title>
        <meta
          name="description"
          content={`Proyecto destacado: ${cards[currentIndex].title} - ${cards[currentIndex].content}. Sistemas fotovoltaicos y soluciones solares de Ipsum Ingeniería.`}
        />
        <meta
          name="keywords"
          content={`clientes, instalaciones solares, energía renovable, paneles solares, sistemas fotovoltaicos, Ipsum Ingeniería, ${cards[currentIndex].title}, Norte de Santander, Cúcuta`}
        />
        <meta name="robots" content="index, follow" />
        {/* Open Graph */}
        <meta
          property="og:title"
          content={`${cards[currentIndex].title} | Ipsum Ingeniería`}
        />
        <meta property="og:description" content={cards[currentIndex].content} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://www.ipsumiei.com.co/clientes/termosolares/${cards[
            currentIndex
          ].title
            .toLowerCase()
            .replace(/\s+/g, '-')}`}
        />
        <meta property="og:image" content={cards[currentIndex].image} />
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={`${cards[currentIndex].title} | Ipsum Ingeniería`}
        />
        <meta
          name="twitter:description"
          content={cards[currentIndex].content}
        />
        <meta name="twitter:image" content={cards[currentIndex].image} />
      </Helmet>

      <div className="background-overlay" />
      <div className="background" />

      <div className={`pro-background-text active`}>
        <h2>{cards[currentIndex].title}</h2>
        <p>{cards[currentIndex].content}</p>
        <button className="ver-proyecto-btn" onClick={handleVerProyectoClick}>
          VER PROYECTO{' '}
          <svg viewBox="0 0 180 45" preserveAspectRatio="none">
            <rect x="0" y="0" width="180" height="45"></rect>
          </svg>
        </button>
      </div>

      <div
        className="pro-indicator-arrow-i"
        onClick={() => handleIndicatorArrowClick(-1)}
      >
        ‹
      </div>

      <div className="carousel-wrapper">
        <div
          className="card-carousel carousel-container"
          ref={carouselRef}
          onTouchStart={(e) => e.stopPropagation()}
          onTouchMove={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
        >
          {cards.map((card, index) => (
            <div
              key={card.id}
              className={`card ${index === currentIndex ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${
                  isMobile && card.imageMobile ? card.imageMobile : card.image
                })`,
              }}
              onClick={() => handleCardClick(index)}
            >
              <h2>{card.title}</h2>
            </div>
          ))}
        </div>

        {/* Mantén las flechas solo aquí */}
        <div className="indicators-container">
          <div
            className="indicator-arrow"
            onClick={() => handleIndicatorArrowClick(-1)}
          >
            ‹
          </div>

          {cards.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => handleDotClick(index)}
            />
          ))}

          <div
            className="indicator-arrow"
            onClick={() => handleIndicatorArrowClick(1)}
          >
            ›
          </div>
        </div>
      </div>

      <div
        className="pro-indicator-arrow-d"
        onClick={() => handleIndicatorArrowClick(1)}
      >
        ›
      </div>

      {showModal && (
        <div className="cliente-modal-overlay modal-container">
          <div className="cliente-modal">
            <button className="close-button" onClick={handleCloseModal}>
              ×
            </button>

            {clienteComponent || (
              <>
                <h2>{cards[currentIndex]?.title}</h2>
                <img
                  style={{
                    height: '80%',
                    maxWidth: '100%',
                    objectFit: 'contain',
                  }}
                  src={cards[currentIndex]?.image}
                  alt={cards[currentIndex]?.title}
                />
                <p>{cards[currentIndex]?.content}</p>
              </>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Proyectos;
